export const BRANDS_NAV = [
  {
    "title": "Asuransi Berdasarkan Merk Kendaraanmu",
    "link": "#",
    "childItems": [
      {
        "title": "Asuransi Mobil Toyota",
        "link": "/produk/asuransi-mobil/toyota/",
      },
      {
        "title": "Asuransi Mobil Honda",
        "link": "/produk/asuransi-mobil/honda/",
      },
      {
        "title": "Asuransi Mobil Suzuki",
        "link": "/produk/asuransi-mobil/suzuki/",
      },
      {
        "title": "Asuransi Mobil Nissan",
        "link": "/produk/asuransi-mobil/nissan/",
      },
      {
        "title": "Asuransi Mobil Mazda",
        "link": "/produk/asuransi-mobil/mazda/",
      },
      {
        "title": "Asuransi Mobil BYD",
        "link": "/produk/asuransi-mobil/byd/",
      },
      {
        "title": "Asuransi Mobil Hyundai",
        "link": "/produk/asuransi-mobil/hyundai/",
      },
      {
        "title": "Asuransi Mobil Wuling",
        "link": "/produk/asuransi-mobil/hyundai/",
      },
      {
        "title": "Asuransi Mobil Daihatsu",
        "link": "/produk/asuransi-mobil/daihatsu/",
      },
      {
        "title": "Asuransi Mobil Mitsubishi",
        "link": "/produk/asuransi-mobil/mitsubishi/",
      },
      {
        "title": "Asuransi Mobil Mercedes Benz",
        "link": "/produk/asuransi-mobil/mercedes-benz/",
      },
      {
        "title": "Asuransi Mobil Datsun",
        "link": "/produk/asuransi-mobil/datsun/",
      },
      {
        "title": "Asuransi Mobil Kia",
        "link": "/produk/asuransi-mobil/kia/",
      },
      {
        "title": "Asuransi Mobil Chevrolet",
        "link": "/produk/asuransi-mobil/chevrolet/",
      },
      {
        "title": "Asuransi Mobil BMW",
        "link": "/produk/asuransi-mobil/bmw/",
      },
    ]
  },
];